import { ComponentProps } from 'react'

import cn from '@/utilities/cn'

export default function Page({ children, className }: ComponentProps<'div'>) {
  return <div className={cn('fade-in mx-auto w-full max-w-[1920px] transition-all', className)}>{children}</div>
}
